module.exports = __webpack_public_path__ + "static/feature-1-398741b49bf0e765279813bac4e40c1b.svg";